import { Injectable } from "@angular/core";
import { IKpiSnapshot } from "@gtmhub/kpis";
import { localize } from "@gtmhub/localization";
import { KpiLastSnapshot } from "@webapp/kpis/models/kpi-snapshot.models";
import { Kpi } from "@webapp/kpis/models/kpis.models";
import { cancelButton, primaryButton } from "@webapp/shared/modal/modal.utils";
import { UiModalRef } from "@webapp/ui/modal/abstracts/modal-ref";
import { UiModalService } from "@webapp/ui/modal/services/modal.service";
import { KpiSnapshotFormComponent, KpiSnapshotFormModalData } from "./kpi-snapshot-form.component";

@Injectable({
  providedIn: "any",
})
export class KpiSnapshotModalService {
  public constructor(private modalService: UiModalService) {}

  public openKpiSnapshotModal(kpi: Kpi, snapshots: IKpiSnapshot[]): UiModalRef<KpiSnapshotFormComponent, boolean> {
    const lastSnapshot: KpiLastSnapshot = snapshots[snapshots.length - 1];
    return this.createKpiSnapshotModal(kpi, lastSnapshot);
  }

  private createKpiSnapshotModal(kpi: Kpi, lastSnapshot: KpiLastSnapshot): UiModalRef<KpiSnapshotFormComponent, boolean> {
    return this.modalService.create<KpiSnapshotFormComponent, KpiSnapshotFormModalData>({
      uiContent: KpiSnapshotFormComponent,
      uiData: { kpi, lastSnapshot },
      uiTitle: localize("update_kpi"),
      uiFooter: [
        primaryButton(localize("submit"), {
          disabled: (component) => component.form?.invalid || component.isHttpRequestInProgress,
          onClick: (component) => {
            component.onSubmit();

            // closing is handled in onSubmit based on the http operation response
            return false;
          },
        }),
        cancelButton(),
      ],
      uiWidth: 682,
    });
  }
}
